import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';
import { Observable } from 'rxjs';

import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  constructor(
    private http: HttpClient,
    private globalService: GlobalService
  ) { 

  }

  newGroup(token, newGroup): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.newGroupURL, newGroup, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  };
  
  getGroups(token): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getGroupsURL, httpOptions);
  }

  getGroup(token, groupId): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getGetGroupURL(groupId), httpOptions);
  }

  delGroup(token, groupId): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.delete<any>(this.globalService.getDeleteGroupURL(groupId), httpOptions);
  }

  delMember(token, id, obj): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.getDelMembersGroupURL(id), obj, httpOptions);
  }

  addMember(token, id, obj): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.getAddMembersToGroupURL(id), obj, httpOptions);
  }

  updateNameGroup(token, id, obj){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.getUpdateGroupNameURL(id), obj, httpOptions);
  }

}